import { Link, Outlet, useLocation } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import { Tabs, TabsList, TabsTrigger } from "design-system/molecules/Tabs"
import { isNil } from "lopermut"
import { Cpu, Gift, Layers } from "lucide-react"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { useGetBillingPortalUrl } from "modules/subscription/hooks/useGetBillingPortalUrl"
import { useSubscriptionData } from "modules/subscription/hooks/useSubscriptionData"
import { canSeeReferrals } from "modules/subscription/lib/canSeeReferrals"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export function SubscriptionTabs() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { data: employee } = useAuthEmployeeQuery()
  const { activeSubscriptionName } = useSubscriptionData()

  const { data: portalUrl } = useGetBillingPortalUrl()
  const showReferrals = canSeeReferrals(employee, activeSubscriptionName)

  const value = useMemo(() => {
    if (pathname.includes("/referrals")) return "referrals"
    if (pathname.includes("/plans")) return "plans"
    return "usage"
  }, [pathname])

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-4 w-full justify-between">
        <Tabs value={value}>
          <TabsList>
            <TabsTrigger value="usage" asChild>
              <Link to="/settings/subscription/usage">
                <Cpu size={20} />
                <span>{t("subscription.tabs.usage")}</span>
              </Link>
            </TabsTrigger>
            <TabsTrigger value="plans" asChild>
              <Link to="/settings/subscription/plans">
                <Layers size={20} />
                <span>{t("subscription.tabs.plans")}</span>
              </Link>
            </TabsTrigger>
            {showReferrals && (
              <TabsTrigger value="referrals" asChild>
                <Link to="/settings/subscription/referrals">
                  <Gift size={20} />
                  <span>{t("subscription.tabs.referrals")}</span>
                </Link>
              </TabsTrigger>
            )}
          </TabsList>
        </Tabs>
        {!isNil(portalUrl) && (
          <Button variant="secondary" onClick={() => window.open(portalUrl, "_blank")}>
            <span>{t("subscription.tabs.billingPortal")}</span>
          </Button>
        )}
      </div>
      <Outlet />
    </div>
  )
}
